<ng-template *ngTemplateOutlet="profileMode && allCustomForProfile ? profileSettingsSummary : settingsSummary">
</ng-template>

<ng-template #settingsSummary>
  <div [class]="profileMode ? 'bg-secondary border rounded mt-3' : ''">
    <div *ngIf="keyTitleList.length && showGeneralAlerts">
      <div class="fw-semibold mx-3 my-2">
        {{ title }}
      </div>
      <table class="w-100">

        <tr *ngFor="let item of keyTitleList"
            class="row">
          <td *ngIf="resultInfo[item]?.enabled && generalAlerts.indexOf(item) !== -1"
              class="ml-3 my-2 col-5">
            {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.' + item | i18next }}
          </td>

          <td *ngIf="resultInfo[item]?.enabled && generalAlerts.indexOf(item) !== -1"
              class="my-2 col-6">
            <div *ngFor="let subItem of keyListByArrayValue[item]"
                 class="mb-2">
              {{ subItem }}
            </div>
          </td>
        </tr>
      </table>

    </div>

    <div *ngIf="keyTitleList.length && showWindowsAlerts">
      <div class="fw-semibold mx-3 my-2">
        {{ titleForWinAlerts }}
      </div>
      <table class="w-100">

        <tr *ngFor="let item of keyTitleList"
            class="row">
          <td *ngIf="resultInfo[item]?.enabled && windowsAlerts.indexOf(item) !== -1"
              class="ml-3 my-2 col-5">
            {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.' + item | i18next }}
          </td>

          <td *ngIf="resultInfo[item]?.enabled && windowsAlerts.indexOf(item) !== -1"
              class="my-2 col-6">
            <div *ngFor="let subItem of keyListByArrayValue[item]"
                 class="mb-2">
              {{ subItem }}
            </div>
          </td>
        </tr>
      </table>

    </div>
  </div>
</ng-template>

<ng-container *ngIf="!this.showAlertsOnly && !allCustomForProfile && canShowPostActions">
  <ng-template *ngTemplateOutlet="showGeneral"></ng-template>
</ng-container>

<ng-template #profileSettingsSummary>
  <div *ngFor="let item of keyTitleList">
    <div *ngIf="resultInfo[item]?.enabled || item ==='general'"
         class="bg-secondary border rounded mt-3">
      <div class="m-3">
        <h4>{{ 'mbs-ui:rmm-custom-alerting.wizard.steps.' + item | i18next }}</h4>
      </div>
      <hr class="bg-grey-100"
          *ngIf="canShowThresholdInCustom(item) as canShow">

      <div class="m-3">
        <div class="fw-bold mt-3 mb-2"
             *ngIf="canShow">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.thresholds' | i18next }}
        </div>
        <div *ngFor="let subItem of keyListByArrayValue[item]"
             class="my-2">
          {{ subItem }}
        </div>


        <div *ngIf="allCustomForProfile && canShowPostActions">
          <div
               *ngIf="profilePostAction[item]?.showProvider || profilePostAction[item]?.showEmailRecipients || profilePostAction[item]?.showPushRecipients">
            <div>

              <div *ngIf="profilePostAction[item]?.showProvider || profilePostAction[item]?.showEmailRecipients">
                <div class="fw-bold mt-3 mb-2">
                  {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.emailNotifications' | i18next }}
                </div>
                <div>
                  <span>{{ profilePostAction[item]?.showProvider ? providerEmail : '' }}</span>
                  <span>{{ profilePostAction[item]?.showProvider && profilePostAction[item]?.recipient?.emails?.length ?
                    ', ' : '' }}</span>
                  <span>{{ profilePostAction[item]?.recipient?.emails?.join(', ') }}</span>
                </div>
              </div>

              <div *ngIf="profilePostAction[item]?.showPushRecipients">
                <div class="fw-semibold mt-3 mb-2">
                  {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.sendPushNewTitle' | i18next }}
                </div>
                <div class="my-3">
                  {{ (profilePostAction[item]?.pushRecipientNamesStream$ | async) ?? ('shared:validation.noAdministrator' |
                  i18next) }}
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="profilePostAction && profilePostAction[item]?.connectWise?.enabled">
            <div class="fw-bold mt-3 mb-2">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.openTicketAtConnectWise' | i18next }}
            </div>
            <div>
              {{ 'shared:common.enabled' | i18next : { format: 'title' } }}
            </div>
          </div>

          <div
               *ngIf="profilePostAction[item]?.windowsScriptGuid || profilePostAction[item]?.linuxScriptGuid || profilePostAction[item]?.macOsScriptGuid">
            <div class="fw-bold mt-3 mb-2">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.startScriptIfSetOnAlert' | i18next }}
            </div>
            <div *ngIf="profilePostAction[item]?.windowsScriptGuid"
                 class="row">
              <div class="col-5 mr-2">
                {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.windows' | i18next }}
              </div>
              <div class="col ml-1">
                {{ getScriptNameStream(profilePostAction[item]?.windowsScriptGuid) | async }}
              </div>
            </div>

            <div *ngIf="profilePostAction[item]?.linuxScriptGuid"
                 class="row">
              <div class="col-5 mr-2">
                {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.linux' | i18next }}
              </div>
              <div class="col ml-1">
                {{ getScriptNameStream(profilePostAction[item]?.linuxScriptGuid) | async }}
              </div>
            </div>

            <div *ngIf="profilePostAction[item]?.macOsScriptGuid"
                 class="row">
              <div class="col-5 mr-2">
                {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.macos' | i18next }}
              </div>
              <div class="col ml-1">
                {{ getScriptNameStream(profilePostAction[item]?.macOsScriptGuid) | async }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>


<ng-template #showGeneral>
  <div class="bg-secondary border rounded mt-3"
       *ngIf="profilePostAction['general']?.showProvider || profilePostAction['general']?.showEmailRecipients || profilePostAction['general']?.showPushRecipients || profilePostAction['general']?.connectWise?.enabled
    || profilePostAction['general']?.windowsScriptGuid || profilePostAction['general']?.linuxScriptGuid || profilePostAction['general']?.macOsScriptGuid">
    <div class="m-3">
      <div
           *ngIf="profilePostAction['general']?.showProvider || profilePostAction['general']?.showEmailRecipients || profilePostAction['general']?.showPushRecipients">
        <div>

          <div *ngIf="profilePostAction['general']?.showProvider || profilePostAction['general']?.showEmailRecipients">
            <div class="fw-bold mt-3 mb-2">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.emailNotifications' | i18next }}
            </div>
            <div>
              <span>{{ profilePostAction['general']?.showProvider ? providerEmail?.trim() : '' }}</span>
              <span>{{ profilePostAction['general']?.showProvider &&
                profilePostAction['general']?.recipient?.emails?.length ? ', ' : '' }}</span>
              <span>{{ profilePostAction['general']?.recipient?.emails?.join(', ') }}</span>
            </div>
          </div>

          <div *ngIf="profilePostAction['general']?.showPushRecipients">
            <div class="fw-semibold mt-3 mb-2">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.sendPushNewTitle' | i18next }}
            </div>
            <div class="my-3">
              {{ (profilePostAction['general']?.pushRecipientNamesStream$ | async) ?? ('shared:validation.noAdministrator' |
              i18next) }}
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="profilePostAction['general']?.connectWise?.enabled">
        <div class="fw-bold mt-3 mb-2">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.openTicketAtConnectWise' | i18next }}
        </div>
        <div>
          {{ 'shared:common.enabled' | i18next : { format: 'title' } }}
        </div>
      </div>

      <div
           *ngIf="profilePostAction['general']?.windowsScriptGuid || profilePostAction['general']?.linuxScriptGuid || profilePostAction['general']?.macOsScriptGuid">
        <div class="fw-bold mt-3 mb-2">
          {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.startScriptIfSetOnAlert' | i18next }}
        </div>
        <div *ngIf="profilePostAction['general']?.windowsScriptGuid"
             class="row">
          <div class="col-5 mr-2">
            {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.windows' | i18next }}
          </div>
          <div class="col ml-1">
            {{ getScriptNameStream(profilePostAction['general']?.windowsScriptGuid) | async }}
          </div>
        </div>

        <div *ngIf="profilePostAction['general']?.linuxScriptGuid"
             class="row">
          <div class="col-5 mr-2">
            {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.linux' | i18next }}
          </div>
          <div class="col ml-1">
            {{ getScriptNameStream(profilePostAction['general']?.linuxScriptGuid) | async }}
          </div>
        </div>

        <div *ngIf="profilePostAction['general']?.macOsScriptGuid"
             class="row">
          <div class="col-5 mr-2">
            {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.macos' | i18next }}
          </div>
          <div class="col ml-1">
            {{ getScriptNameStream(profilePostAction['general']?.macOsScriptGuid) | async }}
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
